<template>
  <div id="event">
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <section id="event-1" class="page">
          <div class="section container">
            <div class="title">
              <h1>中壢事件</h1>
              <div class="title_underline"></div>
            </div>
            <div class="section_title animated fadeInLeft">
              事件遠因
            </div>
            <div class="content">
              <img src="../assets/images/event-1.png" alt="" srcset="../assets/images/event-1@2x.png 2x" class="img-fluid">
              <p>
                過去臺灣社會流傳著一句話——「第一憨，選舉運動」，因為每次選舉的當選人早就已經決定好了！在《選舉萬歲》一書中姚嘉文提到，若你是所謂的「黨外人士」，在參選時公開表態支持你的民眾、助選的親朋好友會遭到威脅、恐嚇，而你也會被扣上「共產黨」、「危險份子」的帽子。
              </p>
            </div>
          </div>
        </section>
        <section id="event-2" class="page">
          <div class="section container">
            <div class="content">
              <p>
                投票時，則會有警察及治安人員在一旁監視，也可能遇到作票而成為廢票，當然，也有另一派說法表示，這些是黨外人士慣用的「說法」，以博取民眾的同情票。不過無法否認人民對於這樣的行為，一方面認為表面的選舉真的很傻，一方面忍受著不滿而不敢作聲。
              </p>
            </div>
          </div>
        </section>
        <section id="event-3" class="page">
          <div class="section container">
            <div class="section_title animated">
              事件爆發
            </div>
            <div class="content">
              <img src="../assets/images/event-2.png" alt="" srcset="../assets/images/event-2@2x.png 2x" class="img-fluid">
              <p>
                1977年11月19日投票日當天，邱奕彬看見范姜新林（時任中壢國小校長）走進一對老夫婦的圈票處，疑似將選票塗毁，范姜新林被移送中壢分局做說明，但檢察官未向民眾說明清楚即讓他回到投開票所工作，到了當天下午又有人目睹他作票，這次不滿的群眾聚集在警察局前，要求警察交出范姜新林，檢察官卻以收押之理由悄悄帶其從後門離開。
              </p>
            </div>
          </div>
        </section>
        <section id="event-4" class="page">
          <div class="section container">
            <div class="content">
              <p>
                終於，民眾長期積累的怨氣在此刻爆發，他們丟擲石頭、推翻警車，警察則發射催淚瓦斯、開槍，導致兩名青年不治身亡、一名青年重傷，流血事件更激化了衝突，群眾開始放火燒車，最後連中壢分局都燒起來了，這把火，點燃了臺灣的群眾運動，此事件被稱為「中壢事件」。
              </p>
              <img src="../assets/images/event-3.png" alt="" srcset="../assets/images/event-3@2x.png 2x" class="img-fluid">
              <p>
                由於中壢事件的發生，當天桃園其它投票所開票時都格外小心謹慎，最終許信良以23萬多票贏過對手歐憲瑜的14萬多票，高票當選。
              </p>
            </div>
          </div>
        </section>
        <section id="event-5" class="page">
          <div class="section container">
            <div class="section_title animated">
              事件之後
            </div>
            <div class="content">
              <img src="../assets/images/event-4.png" alt="" srcset="../assets/images/event-4@2x.png 2x" class="img-fluid">
              <p>
                在事件次日，各報導都以極小的篇幅報導中壢事件，內容多以「二一三號投票所發生糾紛」將事件輕描淡寫帶過，直到一星期後，《聯合報》才以全版篇幅報導。
              </p>
              <p>
                該年十二月，檢察官對范姜新林以「證據不足」做出不起訴處份，而原先作為中壢事件證人的邱奕彬則被以「任意誣蔑依法執行任務之選舉監察人」起訴，最終被判有期徒刑一年半，緩刑三年。
              </p>
            </div>
          </div>
        </section>
        <section id="event-6" class="page">
          <div class="section container">
            <div class="content">
              <p>
                中壢事件的餘波，一直延續到1979年1月的橋頭事件，以及1979年的12月的美麗島事件，此為後話。
              </p>
            </div>
            <div class="reference">
              參考資料，皆為2018年11月取用：
              <br/>
              《百年追求：臺灣民主運動的故事》，2015年9月初版12刷
              <br/>
              《選舉萬歲》序文 https://bit.ly/2DuVKVq，2007年4月
              <br/>
              《公道何在：中壢事件及偽證案、選舉萬歲查禁內幕》，1978年10月初版
              <br/>
              報導者文章【中壢事件40周年】許信良：群眾火燒警局時，我在三溫暖睡覺，2017年11月
              <br/>
              https://www.twreporter.org/a/zhongli-incident-40-years
              <br/>
              台灣演義：中壢事件 https://youtu.be/TJJU_t4tdB4，2017年11月
              <br/>
              《選戰風雲》，1978年1月初版
            </div>
          </div>
        </section>
      </div>
      <div class="pager">
        <a href="javascript:void(0);"
           v-for="btn in pageNum"
           :class="{active:index == btn - 1}"
           @click="moveTo(btn - 1)">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Event',
    mounted: function () {
      this.$root.title = '中壢事件';
    },
    data: function () {
      let self = this;

      return {
        index: 0,
        pageNum: 6,
        opts: {
          start: 0,
          beforeChange: function (ele, current, next) {
            self.index = next;
          },
          afterChange: function (ele, current) {
            self.index = current;
            $('.section_title').removeClass('fadeInLeft');
            $(ele).find('.section_title').addClass('fadeInLeft');
          },
        }
      }
    },
    methods: {
      moveTo: function (index) {
        this.$refs.example.$fullpage.moveTo(index, true);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/css/global";

  #event {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    h1 {
      width: 100%;
      background: url("../assets/event.svg") center center no-repeat;
      text-indent: 200%;
      overflow: hidden;
      white-space: nowrap;

      @include media-breakpoint-down(sm) {
        background-position: left center;
      }
    }

    .reference {
      width: 100%;
      font-size: 16px;
      color: #989898;

      @include media-breakpoint-down(sm) {
        font-size: 12px;
      }
    }
  }
</style>
